import { dictionary } from "../helpers";

export function authHeader() {
  // return authorization header with jwt token
  const user = localStorage.getItem(dictionary.constants.authentication.jwt);

  if (user && JSON.parse(user).token) {
    return {
      Authorization: "Bearer " + JSON.parse(user).token
    };
  } else {
    return {};
  }
}
